/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * API区分 (0:P0, 1:API)
 * @export
 * @enum {number}
 */
export enum CategoryEnum {
    /** P0 */
    P0 = '0',
    /** API */
    API = '1'
}

/**
 * API区分 (0:P0, 1:API) の Union 型
 * @export
 * @typedef Category
 */
export type Category =
  typeof CategoryEnum[keyof typeof CategoryEnum];

/**
 * API区分 (0:P0, 1:API) のラベルマップ
 * @export
 */
export const CategoryLabels = {
    /**
     * 数値キー: CategoryEnum.P0
     * 名前キー:  P0
     */
    [CategoryEnum.P0]: 'P0',
    P0:                             'P0',
    /**
     * 数値キー: CategoryEnum.API
     * 名前キー:  API
     */
    [CategoryEnum.API]: 'API',
    API:                             'API',
} as const;

/**
 * API区分 (0:P0, 1:API) のラベル Union 型
 * @export
 * @typedef CategoryLabel
 */
export type CategoryLabel =
  typeof CategoryLabels[keyof typeof CategoryLabels];

/**
 * API区分 (0:P0, 1:API) のラベル取得関数
 * @export
 * @param { Category } value - 列挙体の値
 * @returns { CategoryLabel } ラベル文字列
 */
export function getCategoryLabel(
  value: Category
): CategoryLabel {
  return CategoryLabels[value];
}

/**
 * API区分 (0:P0, 1:API) のラベル配列を取得する関数
 * @export
 * @param { Category[] } values - 列挙体の値配列
 * @returns { CategoryLabel[] } ラベル文字列配列
 */
export function getCategoryLabels(values: Category[]): CategoryLabel[] {
  return values.map((value) => getCategoryLabel(value));
}

/**
 * API区分 (0:P0, 1:API) のラベル配列
 * @export
 */
export const CategoryLabelList = [
  'P0','API',
] as const;

